import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import { getTotalVoted } from '../../../shared/services/ResultsService';
import Counter from '../../../shared/components/Counter';
import Image from '../../../shared/components/Image';
import Step1 from '../../../assets/images/howToSteps/1.png';
import Step2 from '../../../assets/images/howToSteps/2.png';
import Step3 from '../../../assets/images/howToSteps/3.png';
import Loading from '../../../shared/components/Loading';
import Paragraph from '../../../shared/components/Paragraph';
// import Button from '../../../shared/components/Button';
import Section from '../../../shared/components/Section';
import { SocialButtons } from '../../../shared/components/SocialButtons';
import TwoCols from '../../../shared/structure/TwoCols';

const DIALOG_VOTE_ID = '8';

const useStyles = makeStyles(() => ({
  negativeMarginLeft: {
    marginLeft: -22,
  },
}));

export default function DialogContainer() {
  const { t } = useTranslation();
  const [total, setTotal] = useState(null);
  const [totalYes, setTotalYes] = useState(null);

  const [totalLoaded, setTotalLoaded] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    getTotalVoted().then(
      (stats) => {
        const total = stats.Polls.find((poll) => poll.Id === DIALOG_VOTE_ID);
        setTotal(total.TotalVoted);
        setTotalYes(stats.Dialog);
        setTotalLoaded(true);
      },
      () => {
        setTotalLoaded(true);
      },
    );
  }, []);

  return (
    <>
      <Section
        background="blue"
        title={t('dialog_header')}
      />

      <Section
        background="white"
        content={(
          <>
            <TwoCols
              left={(
                <>
                  <Paragraph bold>
                    <Trans i18nKey="dialog_description_header"/>
                  </Paragraph>
                  <Paragraph>
                    <Trans i18nKey="dialog_description" />
                  </Paragraph>
                  <Paragraph bold>
                    <Trans i18nKey="dialog_call_to_action"/>
                  </Paragraph>
                  <SocialButtons />
                </>
              )}
              right={(
                <>
                  {totalLoaded ? (
                    <>
                      <Counter
                        title={t('dialog_counter_title_total')}
                        total={total || 0}
                        color="black"
                      />
                      <Counter
                        title={t('dialog_counter_title')}
                        total={totalYes || 0}
                        color="black"
                      />
                    </>
                  ) : <Loading />}
                </>
              )}
            />
          </>
        )}
      />

      <Section
        background="gray"
        title={t('dialog_section_about_title')}
      />

      <Section
        background="white"
        title={t('dialog_section_about_subtitle')}
        content={(
          <>
            <Paragraph>
              <Trans
                i18nKey="dialog_section_about_text"

              />
            </Paragraph>
          </>
        )}
      />

      <Section
        background="gray"
        title={t('dialog_setup_header')}
      />

      <Section
        background="white"
        content={(
          <>
            <Paragraph title={t('dialog_setup_instruction_title')}>
              <Trans
                i18nKey="dialog_setup_instruction_text"
              />
            </Paragraph>

            <SocialButtons />
          </>
        )}
      />

      <Section
        background="white"
        content={(
          <div className={classes.negativeMarginLeft}>
            <Image src={Step1} />
            <Image src={Step2} />
            <Image src={Step3} />
          </div>
        )}
      />

      <Section
        background="white"
        content={(
          <>
            <Paragraph title={t('dialog_setup_howitworks_title')}>
              <Trans
                i18nKey="dialog_setup_howitworks_text"
              />
            </Paragraph>
            {/*<Paragraph title={t('dialog_setup_howitworks_no_phone_title')}>*/}
            {/*  <Trans*/}
            {/*    i18nKey="dialog_setup_howitworks_no_phone_text_1"*/}
            {/*  />*/}
            {/*</Paragraph>*/}
            {/*<Button*/}
            {/*  background="blue"*/}
            {/*  text={t('dialog_setup_howitworks_no_phone_link')}*/}
            {/*  href="https://golos2020-calls.org/"*/}
            {/*  target="_blank"*/}
            {/*/>*/}
            {/*<Paragraph>*/}
            {/*  <Trans*/}
            {/*    i18nKey="dialog_setup_howitworks_no_phone_text_2"*/}
            {/*  />*/}
            {/*</Paragraph>*/}
            {/*<Paragraph bold>*/}
            {/*  <Trans*/}
            {/*    i18nKey="dialog_setup_howitworks_no_phone_text_3"*/}
            {/*  />*/}
            {/*</Paragraph>*/}
          </>
        )}
      />
    </>
  );
}
